<template>
<div class="main-body">
  <div class="card">
      <div class="card-body">
          <div class="row">
              <div class="col-sm-5">
                  <h4 class="card-title mb-0">
                    Marketplace FAQ Management
                  </h4>
              </div><!--col-->

              <div class="col-sm-7">
                  <header-button></header-button>
              </div><!--col-->
          </div><!--row-->
        <hr />
        <faq-filters :filter="filter" :fetchMarketplaceFaqs="searchMarketplaceFaqs"></faq-filters>
          <div class="row mt-4">
              <div class="col">
                  <div class="table-responsive">
                      <table class="table">
                        <colgroup>
                          <col width="2%">
                          <col width="8%">
                          <col width="10%">
                          <col width="50%">
                          <col width="8%">
                          <col width="8%">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>No.</th>
                            <th>{{ $t('marketplace.faq.created_date') }}</th>
                            <th>{{ $t('marketplace.faq.platform') }}</th>
                            <th>{{ $t('marketplace.faq.title') }}</th>
                            <!-- <th>{{ $t('marketplace.faq.content') }}</th> -->
                            <th>{{ $t('marketplace.faq.status') }}</th>
                            <th>{{ $t('marketplace.faq.operation') }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(marketplaceFaq, index) in marketplaceFaqs" :key="index">
                            <td>{{ index+1 }}</td>
                            <td>{{ marketplaceFaq.created_at }}</td>
                            <td>{{ marketplaceFaq.platform }}</td>
                            <td><a href="#" @click="showFaqDetail(marketplaceFaq)">{{ marketplaceFaq.title }}</a></td>
                            <!-- <td>{{ marketplaceFaq.content }}</td> -->
                            <td>
                              <span class="badge badge-success" v-if="marketplaceFaq.status">{{ $t('marketplace.faq.active') }}</span>
                              <span class="badge badge-secondary" v-else>{{ $t('marketplace.faq.in_active') }}</span>
                            </td>
                            <td>
                              <router-link :to="{ path: '/marketplace/faq/' + marketplaceFaq.id + '/edit' }">
                                <b-button variant="primary btn-sm ml-1"><i class="fa fa-pencil"></i></b-button>
                              </router-link>
                               <b-button variant="danger btn-sm ml-1" @click.stop.prevent="handleDelete(marketplaceFaq.id)"><i class="fa fa-trash"></i></b-button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                  </div>
              </div><!--col-->
          </div><!--row-->
      </div><!--card-body-->
  </div><!--card-->
  <loading-panel v-if="showLoadingPanel"></loading-panel>
  <CModal
    title="Faq Detail"
    :show.sync="modalDetailShow"
    color="primary"
    size="lg"
  >
    <faq-detail :marketplaceFaq="selectedFaqDetail"></faq-detail>
    <div slot="footer"></div>
  </CModal>
</div>
</template>

<script>
import HeaderButton from '@/views/components/marketplace/faq/HeaderButton'
import FaqFilters from '@/views/components/marketplace/faq/FaqFilters'
import FaqDetail from '@/views/components/marketplace/faq/FaqDetail'
import LoadingPanel from '@/components/LoadingPanel'

export default {
  name: 'Faq',
  components: {
    HeaderButton,
    FaqFilters,
    LoadingPanel,
    FaqDetail
  },
  mounted () {
    this.searchMarketplaceFaqs() 
  },
  data () {
    return {
      marketplaceFaqs: [],
      filter: {
        title: '',
        platform: null,
        status: 1,
      },
      selectedFaqDetail: null,
      modalDetailShow: false,
      showLoadingPanel: false
    }
  },
  methods: {
    searchMarketplaceFaqs(){
      this.axios.get('/marketplace/faq', {
        params: this.filter
      }).then(response => {
        this.marketplaceFaqs = response.data
      }).catch(error => {
        console.log(error)
      })
    },
    showFaqDetail(item){
      this.selectedFaqDetail = item
      this.modalDetailShow= true
    },
    handleDelete (faqId) {
      this.$swal({
        title: this.$t('operation.delete.title'),
        text: this.$t('operation.delete.text'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('operation.delete.confirm_button')
      }).then((result) => {
        if (result.value) {
          this.showLoadingPanel = true
          this.axios.delete('/marketplace/faq/' + faqId).then(() => {
            // this.showLoadingPanel = false
            // this.$router.push('/marketplace/store')
            location.reload()
          }).catch(error => {
            this.showLoadingPanel = false
            this.$swal({
              icon: 'error',
              title: error.data.message
            })
          })
        }
      })
    }
  }
}
</script>
